// Connections the backend creates as a side effect of connecting another
// platform. Mirrors DERIVED_CONNECTIONS in backend/database.py.
export const DERIVED_PLATFORMS = {
  instagram_via_facebook: ['facebook'],
};
